import { createSelector, createSlice } from "@reduxjs/toolkit";
import { getBaseSlice } from "../base.slice";
import { RootState } from "../../store";
import { User } from "firebase/auth";

const { initialState, reducers } = getBaseSlice<User>();

const myInfoSlice = createSlice({
  name: "auth/my-info",
  initialState: {
    ...initialState,
    loading: true,
  },
  reducers,
});

export const {
  reducer: myInfoReducer,
  actions: {
    setData: setMyInfo,
    setLoading: setLoadingMyInfo,
    setError: setErrorMyInfo,
    clearData: clearMyInfo,
  },
} = myInfoSlice;

export const myInfoStateSelector = createSelector(
  ({ myInfo: { data, loading, error } }: RootState) => ({
    myInfo: data,
    loading,
    error,
  }),
  (state) => state
);

export const myInfoSelector = createSelector(
  ({ myInfo: { data } }: RootState) => data,
  (state) => state
);
